import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
import { authenticationTypes } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
const payloadSchema = {
    type: 'object',
    properties: {
        mnemonicId: { type: 'string' },
    },
    required: [],
};
export const getGiveawayEnterLinkEndpoint = {
    [giveawayEndpointIds.GET_GIVEAWAY_ENTER_LINK]: {
        authentication: authenticationTypes.optional,
        endpointType: otherEndpointType,
        payloadSchema,
    },
};
